/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem3
 */
export interface EnumItem3 {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem3
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem3
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem3 interface.
 */
export function instanceOfEnumItem3(value: object): value is EnumItem3 {
    return true;
}

export function EnumItem3FromJSON(json: any): EnumItem3 {
    return EnumItem3FromJSONTyped(json, false);
}

export function EnumItem3FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem3 {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItem3ToJSON(json: any): EnumItem3 {
    return EnumItem3ToJSONTyped(json, false);
}

export function EnumItem3ToJSONTyped(value?: EnumItem3 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

